document.documentElement.classList.remove('no-js');

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-menu-toggle]');
  if (toggle) {
    document.documentElement.classList.toggle('menu-open');
  }

  const close = event.target.closest('[data-menu-close]');
  if (close) {
    document.documentElement.classList.remove('menu-open');
  }
});
